import { ENV } from "../utils";
export class AccidentMechanism {
  baseApi = ENV.BASE_API;
  async getAccidentMechanisms(accessToken, active = true) {
    const r = await fetch(`${this.baseApi}/accident-mechanisms?active=${active}`, { headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async createAccidentMechanism(accessToken, data) {
    const r = await fetch(`${this.baseApi}/add-accident-mechanism`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async updateAccidentMechanism(accessToken, id, data) {
    const r = await fetch(`${this.baseApi}/update-accident-mechanism/${id}`, { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async deleteAccidentMechanism(accessToken, id) {
    const r = await fetch(`${this.baseApi}/delete-accident-mechanism/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
}
